module.exports = __webpack_public_path__ + "img/instrucciones.71dd9c92.png";